export enum UserPanelModule {
  SETTINGS = 'SETTINGS',
  OPINIONS = 'OPINIONS',
  CUSTOM_LOGO = 'CUSTOM_LOGO',
}
